/**
 * Pilot & requests (ROP-teams 0.162.0, Bill 2026-11-04).
 *
 *   /pilot                 Requests: your life-ring reports (and, while the pilot runs, everyone's) as a dashboard:
 *                          tiles, filters, search, status in plain words. Replaces the "My requests" list behind the
 *                          user badge (CHG-0100); the badge's link opens this page.
 *   /pilot/requests/:key   One request: the plain briefing (what, why, what was done, what's left, history).
 *   /pilot/testing         Pilot testing: the pilot test workbook, worked here instead of in passed-around sheets.
 *
 * Bill: pilot testing in spreadsheets is "a waste of time"; reporters' requests "would be better if it had its own
 * Dashboard UI with KPIs, filters, search etc."
 */
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router';
import { RequestsTab } from './RequestsTab';
import { RequestDetail } from './RequestDetail';
import { PilotTestingTab } from './PilotTestingTab';
import '@/modules/Home/styles/home.css';
import './pilot.css';

export default function PilotModule(): JSX.Element {
  const loc = useLocation();
  const navigate = useNavigate();
  const testing = loc.pathname.startsWith('/pilot/testing');

  return (
    <div className="pilot">
      <h1 className="pilot__title">Pilot &amp; requests</h1>
      <p className="pilot__lede">
        Your life-ring reports and where each one stands, and the pilot test plan worked right here. Every update is
        recorded with who made it and when.
      </p>
      <div className="pilot__tabs" role="tablist" aria-label="Pilot and requests">
        <button type="button" role="tab" aria-selected={!testing} className={`pilot__tab${testing ? '' : ' is-on'}`}
          onClick={() => navigate('/pilot')}>
          Requests
        </button>
        <button type="button" role="tab" aria-selected={testing} className={`pilot__tab${testing ? ' is-on' : ''}`}
          onClick={() => navigate('/pilot/testing')}>
          Pilot testing
        </button>
      </div>
      <Routes>
        <Route index element={<RequestsTab />} />
        <Route path="requests/:key" element={<RequestDetail />} />
        <Route path="testing" element={<PilotTestingTab />} />
        <Route path="*" element={<Navigate to="/pilot" replace />} />
      </Routes>
    </div>
  );
}
